import React from "react";
import UnifiedCustomerForm from "./CustomerForm";

const RegisterWalkinCustomerForm = ({
  customer = {},
  onSave,
  onCancel,
  areaCodes,
}) => {
  return (
    <UnifiedCustomerForm
      mode="register"
      customer={customer}
      onSave={onSave}
      onCancel={onCancel}
      areaCodes={areaCodes}
    />
  );
};

export default RegisterWalkinCustomerForm;
